export class UserManagementConst {
  static RETURN_URL = 'ReturnUrl';
  static SSOUSER_EMAIL = 'ssoUserEmail';
  static REMEBERME_COOKIE = 'ACA_REMEMBERED_USER_NAME';
  static CHANGE_PASSWORD_ROUTE = 'Account/ChangePassword.aspx?IsPasswordExpires=Y';
}

